import { useEffect } from 'react';

const useScript = ({ url, load, onLoad }) => {
  useEffect(() => {
    if (!load) {
      return () => {};
    }

    const script = document.createElement('script');

    script.src = url;
    script.async = false;
    script.onload = onLoad;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [load, onLoad, url]);
};

export default useScript;
